import * as React from "react";
import * as ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import "./index.css";
import Home from "./pages/Home";
import Library from "./pages/Library";
import Contact from './pages/contact'
import About from "./pages/About";
import Root from "./Root";
import Foot from "./components/Foot";
import { Toaster } from "sonner";
import { ThemeProvider } from './components/extra/ThemeContext'; 

import home from '../src/audio/home.mp3'
import SpotlightCard from "./components/extra/Dock";
import ClickSpark from "./components/extra/GridDist";
import './styles/extra/dock.css'


const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "library",
        element: <Library />,
      },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
     <ThemeProvider>
      <ClickSpark 
  sparkColor='rgb(0, 74, 211, 0.4)'
  sparkSize={20}
  sparkRadius={15}
  sparkCount={8}
  duration={500}
>
    <SpotlightCard className="custom-spotlight-card" spotlightColor="rgba(0, 103, 181, 0.5)">
      <RouterProvider router={router} /></SpotlightCard>
    <Toaster expand visibleToasts={2} closeButton={true} position="top-center" toastOptions={{
      style: {
        backdropFilter: "6px",
        background: "linear-gradient(to right bottom, rgba(255, 255, 255, 0.7), rgba(0, 0, 0, 0.4))",
        border: "1px solid rgba(255, 255, 255, 0.8)",
        borderRight: "1px solid rgba(0, 0, 0, 0.5)",
        borderBottom: "1px solid rgba(0, 0, 0, 0.5)",
        borderRadius: "10px",
        boxShadow: "10px 16px 50px rgba(0, 0, 0, 0.8)",
        fontSize: '16px',
        fontWeight: "600"
      },
    }} /></ClickSpark></ThemeProvider>
  </React.StrictMode>
);